module.exports = __webpack_public_path__ + "img/ci.71b3f6b8.svg";